/* eslint-disable react/jsx-props-no-spreading */
import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { loadGTM, unloadGTM, checkifGTMLoaded } from './gtm';
import { config } from '../../../config';

const IDS = {
  company: 'G-Y1P0DQQKC3',
  tester: 'G-3PBH5BEHGM',
};

const withGa = (Child) => {
  const WithGaComponent = ({ src, ...props }) => {
    useLayoutEffect(() => {
      const pattern = /^\/(sign-in|sign-up)?$/;
      if (!checkifGTMLoaded()) {
        if (config.REACT_APP_ENABLE_ANALYTICS && config.REACT_APP_PLATFORM_TYPE !== 'admin') {
          loadGTM(IDS[src]);
        } else {
          console.log('Analytics disabled in development mode and admin platform');
        }
      }
      return () => {
        if (!pattern.test(window.location.pathname)) {
          unloadGTM();
        }
      };
    }, []);
    return (
      <Child {...props} />
    );
  };
  WithGaComponent.propTypes = {
    src: PropTypes.string.isRequired,
  };
  return WithGaComponent;
};

export default withGa;
